export default __webpack_public_path__ + "images/056a5dda7e5d1d6a424e3b6209fac9f4.svg";